import { LayerAPI } from "@ai360/core";
import * as analysisModels from "~/recs-events/analysis/model";
import { messages } from "./i18n-messages";

export const layerAccessImagerySetupTypes = (
    layerTypesAccess: LayerAPI.IAnalysisLayerType[],
    formatMessage: (arg0: any) => any,
    onAddAnalysisLayer: (arg0: any[], arg1: string) => any,
    fieldGuids: string[]
): Array<{
    key: number;
    label: string;
    action: () => any;
}> => {
    const imagerySetupLayerTypes = layerTypesAccess
        .filter((t) => t.name.includes("Imagery Setup - "))
        .map((t, index) => {
            switch (t.name) {
                case analysisModels.ANALYSIS_INFO_NAME_IMAGERY_SETUP_PLANET:
                    return {
                        key: index,
                        label: formatMessage(messages.imagerySetupPlanetText),
                        action: () =>
                            onAddAnalysisLayer(
                                fieldGuids,
                                analysisModels.ANALYSIS_INFO_NAME_IMAGERY_SETUP_PLANET
                            ),
                    };
                case analysisModels.ANALYSIS_INFO_NAME_IMAGERY_SETUP_SENTINEL:
                    return {
                        key: index,
                        label: formatMessage(messages.imagerySetupSentinelText),
                        action: () =>
                            onAddAnalysisLayer(
                                fieldGuids,
                                analysisModels.ANALYSIS_INFO_NAME_IMAGERY_SETUP_SENTINEL
                            ),
                    };
            }
        });
    return imagerySetupLayerTypes;
};
